import {
  __spreadValues
} from "./chunk.K2NRSETB.js";

// src/utilities/bytes.ts
var formatThousandsRegExp = /\B(?=(\d{3})+(?!\d))/g;
var formatDecimalsRegExp = /(?:\.0*|(\.[^0]+)0+)$/;
var parseRegExp = /^(([-+])?(\d+(?:\.\d+)?)) *(kb|mb|gb|tb|pb)$/i;
var map = {
  b: 1,
  kb: 1 << 10,
  mb: 1 << 20,
  gb: 1 << 30,
  tb: Math.pow(1024, 4),
  pb: Math.pow(1024, 5)
};
function getUnit(mag, unit) {
  if (!unit || !map[unit.toLowerCase()]) {
    if (mag >= map.pb) {
      return "PB";
    } else if (mag >= map.tb) {
      return "TB";
    } else if (mag >= map.gb) {
      return "GB";
    } else if (mag >= map.mb) {
      return "MB";
    } else if (mag >= map.kb) {
      return "KB";
    }
    return "B";
  }
  return unit;
}
function format(value, options) {
  if (!Number.isFinite(value)) {
    return null;
  }
  const mag = Math.abs(value);
  let settings = {
    thousandsSeparator: "",
    unitSeparator: "",
    decimalPlaces: 2,
    fixedDecimals: false,
    unit: ""
  };
  if (options) {
    settings = __spreadValues(__spreadValues({}, settings), options);
  }
  settings.unit = getUnit(mag, settings.unit);
  const val = value / map[settings.unit.toLowerCase()];
  let str = val.toFixed(settings.decimalPlaces);
  if (!settings.fixedDecimals) {
    str = str.replace(formatDecimalsRegExp, "$1");
  }
  if (settings.thousandsSeparator) {
    const thousandsSeparator = settings.thousandsSeparator;
    str = str.split(".").map((s, i) => {
      return i === 0 ? s.replace(formatThousandsRegExp, thousandsSeparator) : s;
    }).join(".");
  }
  return str + settings.unitSeparator + settings.unit;
}
function parse(val) {
  if (typeof val === "number" && !isNaN(val)) {
    return val;
  }
  if (typeof val !== "string") {
    return null;
  }
  const results = parseRegExp.exec(val);
  let floatValue;
  let unit = "b";
  if (!results) {
    floatValue = parseInt(val, 10);
  } else {
    floatValue = parseFloat(results[1]);
    unit = results[4].toLowerCase();
  }
  if (isNaN(floatValue)) {
    return null;
  }
  return Math.floor(map[unit] * floatValue);
}

export {
  format,
  parse
};
/*!
 * bytes
 * Copyright(c) 2012-2014 TJ Holowaychuk
 * Copyright(c) 2015 Jed Watson
 * MIT Licensed
 */
